import { IAccountRole } from "types/auth";
import { jwtDecode } from "jwt-decode";

interface Itoken {
  institution: string;
  role: IAccountRole;
  email: string;
  user_id: string;
}

export function setCookie(name: string, value: string, days: number) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(c_name: string) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}


export function setToken(token: string){
    setCookie("access_token", token, 7)
}

export function getToken(){
  return getCookie("access_token") || "";
}

export function clearAuthCookies(){
  setToken('');
}

export function decodeToken(): Itoken {
  try {
    const token = getToken();
    const decoded: Itoken = jwtDecode(token);
    return decoded;
  } catch {
    return {} as Itoken;
  }
}


export function isAdminUser(): boolean {
  const decodedToken = decodeToken();
  return decodedToken.role === IAccountRole.ADMIN;
}